
const restaurants = [
    {
      id : 1,
      name: "Le Burger Gourmet",
      image: "/image restaurant/Image (1).png",
      rating: 4.7,
      time: "20-30 min",
      price: "2.50 €",
      description: "Les meilleurs burgers artisanaux de la ville avec des ingrédients frais et locaux.",
    },
    {
      id : 2,
      name: "Pizza Napoli",
      image: "/image restaurant/Image (2).png",
      rating: 4.5,
      time: "25-40 min",
      price: "3.00 €",
      description: "Authentiques pizzas napolitaines cuites au feu de bois.",
    },
    {
        id : 3,
        name: "Sushi Palace",
        image: "/image restaurant/Image (3).png",
        rating: 4.8,
        time: "30-45 min",
        price: "4.00 €",
        description: "Sushis et sashimis préparés par des chefs japonais expérimentés.",
      },
      {
        id : 4,
        name: "Saveurs d'Afrique",
        image: "/image restaurant/Image (10).png",
        rating: 4.6,
        time: "35-50 min",
        price: "3.50 €",
        description: "Cuisine africaine authentique avec des saveurs riches et épicées.",
      },
      {
        id : 5,
        name: "Le Bistrot Parisien",
        image: "/image restaurant/Image (11).png",
        rating: 4.9,
        time: "25-35 min",
        price: "5.00 €",
        description: "Cuisine française traditionnelle revisitée avec des produits de saison.",
      },
      {
        id : 6,
        name: "Douceurs Sucrées",
        image: "/image restaurant/Image (12).png",
        rating: 4.7,
        time: "15-25 min",
        price: "3.00 €",
        description: "Pâtisseries artisanales et desserts gourmands pour tous les goûts.",
      },
  ];
  
  export default restaurants;
  